import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import debounce from 'debounce';

import { Col, Input, message, Row, Select, Switch, InputNumber } from 'antd';

import moment from 'moment';

import { API_ENDPOINT } from '../../../index';

import { 
	setQuotationCurrency,
	setQuotationFreeDelivery, 
	setQuotationPaymentTermDays,
	setQuotationGstWaived
} from '../actions';

import { 
	_getEnterpriseData,
	_postChangeQuotationPoRefNumber,
	_postCustomDeliveryFee,
	_postCustomDeliveryNote,
	_postSetQuotationCurrency,
	_postSetQuotationPaymentTermDays, 
	_postToggleQuotationFreeDelivery,
	_postToggleQuotationGstWaived,
	_postManualDeliveryCharge,
	_putCustomPlatformFee
} from '../../../services';

const { TextArea } = Input;

class QuotationPricing extends React.Component{
	render(){
		
		const { quotation } = this.props;

		const { punchoutCart } = quotation.cart;
		
		return (
			<Row type="flex" gutter={32}>
				<Col style={{ height: 800 / 1.5 }}>

					<object 
						width={800 / 1.5}
						height={650}
						data={this.state.quotationUrl}	
					>
						quotation
					</object>

				</Col>
				<Col >

					<Row align="middle" type="flex" style={{ marginTop: 16 }} gutter={16}>
						<Col>
							<h4>PO Ref Number: </h4>
						</Col>
					</Row>

					<Row align="middle" type="flex" gutter={16}>
						<Col>
							<Input
								disabled={ (quotation.cart.cancelled && quotation.cart.cancelledBy) ||  (quotation.cart.payment && quotation.cart.payment.approverUserId) } 
								defaultValue={ this.props.quotation.cart.poRefNumber }
								onChange={ this.onChangePoRefNumber } />
						</Col>
					</Row>

					<Row>
						<Col>
							{/* Free Delivery */}
							<Row align="middle" type="flex" style={{ marginTop: 16 }} gutter={16}>
								<Col>
									<h4>Free Delivery: </h4>
								</Col>
							</Row>

							<Row align="middle" type="flex" gutter={16}>
								<Col>
									<Switch
										gutter={16}
										disabled={( this.props.quotation.cart.lastContact && this.props.quotation.cart.lastContact.invoiceDate) || this.state.manualDeliverySwitchDisable || punchoutCart} 
										checked={this.props.quotation.cart.quoteAndForgetFreeDelivery} 
										onChange={this.onToggleFreeDelivery}/>
								</Col>
							</Row>

							{/* Custom Delivery Fee */}
							<Row align="middle" type="flex" style={{ marginTop: 16 }} gutter={16}>
								<Col>
									<h4>Custom Delivery Fee: </h4>
									<Input
										defaultValue={this.props.quotation.cart.customDeliveryPrice }
										disabled = {( this.props.quotation.cart.lastContact && this.props.quotation.cart.lastContact.invoiceDate) || this.state.manualDeliveryInputDisable || punchoutCart}
										onChange={( e ) => this.setCustomDeliveryFee(e.target.value)}
										placeholder = "Custom Delivery Fee"/>
								</Col>
							</Row>

							<Row align="middle" type="flex" style={{ marginTop: 16 }} gutter={16}>
								<Col span={24} style={{ width: '100%'}}>
									<h4>Delivery Note: </h4>
									<TextArea 
										rows={4} 
										defaultValue={this.props.quotation.cart.customDeliveryPrice }
										onChange={( e ) => this.setCustomDeliveryNote(e.target.value)}
										placeholder="Delivery Notes here"/>
								</Col>
							</Row>

							{/* Custom Platform Fee */}
							<Row align="middle" type="flex" style={{ marginTop: 16}} gutter={16}>
								<Col>
									<h4>Custom Platform Fee (only for ID orders): </h4>
									<Switch
										checked={this.state.customPlatformFeeActive}
										onChange={(active) => this.setCustomPlatformFee(active, active ? 7 : 0)}
										style={{ marginRight: 8 }}
									/>
									{this.state.customPlatformFeeActive &&
										<InputNumber
											value={this.state.customPlatformFee}
											onChange={(e) => this.setCustomPlatformFee(this.state.customPlatformFeeActive, e)}
										/>
									}
								</Col>
							</Row>
							
							

						</Col>

						<Col>
							<Row type="flex" style={{ marginTop: 16 }} gutter={16}>
								<Col>
									<h4>GST Waived: </h4>
								</Col>
							</Row>
							<Row type="flex" gutter={16}>
								<Col>
									<Switch
										disabled={this.props.noEdit || punchoutCart} 
										checked={this.props.quotation.cart.quoteAndForgetGstWaived} onChange={this.onToggleGstWaived} />
								</Col>
							</Row>
						</Col>
					</Row>

					{ this.renderPaymentTerms() }

					{ this.renderCurrency() }


					<Row style={{ marginTop: 16 }}>
						<Col>
							<h4>Custom Bulk Discount</h4>
						</Col>
					</Row>

					{ this.renderCustomBulkDiscount() }

					{ this.renderLastContact() }
				</Col>
			</Row>
		);
	}

	renderCurrency = () => {

		const { cart } = this.props.quotation;

		const { punchoutCart } = cart;

		const Option = Select.Option;

		let currencies = [
			"SGD",
			"USD",
			"IDR",
			"AUD",
			"MYR"
		];

		return (
			<div style={{ marginTop: 16 }}>
				<h4>Currency:</h4>

				<Select 
					disabled={this.props.noEdit || punchoutCart} 
					value={ cart.currency } 
					style={{ width: 120 }} 
					onChange={ this.updateCurrency }>
					{currencies.map( currency => (
						<Option value={currency}>{currency}</Option>
					))}
				</Select>

			</div>
		)

	}

	renderCustomBulkDiscount = () => {

		const { cart } = this.props.quotation;
		// console.log(cart)

		const products = cart.products.filter( p => p.quoteAndForgetCustomBulkDiscount > 0 );

		if( products.length === 0 ){
			return "NIL";
		}

		return products.map(
			product => (
				<Row type="flex" gutter={8}>
					<Col>
						{product.product.title.length > 20? product.product.title.slice(0,20) : product.product.title } 
					</Col>
					<Col>
						{product.quoteAndForgetCustomBulkDiscount}%
					</Col>
				</Row>
			)
		)
	}
	
	renderLastContact = () => {
		
		const { cart } = this.props.quotation;
		
		if( cart &&  ( !cart.lastContact || !cart.lastContact.quoteAndForgetDate) ){
			return null;
		}
		
		return (
			<div style={{ marginTop: 16 }}> 

				<h4>History</h4>
				{
					//bryce fix: add !cart.lastContact.quoteAndForgetDate 
					cart.lastContact.quoteAndForgetDate && (
						<div>First Email: {moment(cart.lastContact.quoteAndForgetDate).format("llll")}</div>
					)
				}
				
				{
					cart.lastContact.quoteAndForgetFirstReminderDate && (
						<div>First Reminder: {moment(cart.lastContact.quoteAndForgetFirstReminderDate).format("llll")}</div>
					)
				}

				{
					cart.lastContact.quoteAndForgetSecondReminderDate && (
						<div>Second Reminder: {moment(cart.lastContact.quoteAndForgetSecondReminderDate).format("llll")}</div>
					)
				}

				{
					cart.lastContact.quoteAndForgetLastReminderDate && (
						<div>Last Reminder: {moment(cart.lastContact.quoteAndForgetLastReminderDate).format("llll")}</div>
					)
				}
			</div>	
		)
		
	}

	renderPaymentTerms = () => {
		
		const { cart } = this.props.quotation;

		const { punchoutCart } = cart;

		const Option = Select.Option;

		return (
			<div style={{ marginTop: 16 }}>
				<h4>Payment Terms:</h4>

				<Select 
					disabled={this.props.noEdit || punchoutCart} 
					value={ cart.paymentTermDays } 
					style={{ width: 120 }} 
					onChange={ this.updatePaymentTermDays }>
					<Option value={0}>Online Only</Option>
					<Option value={30}>30 Days</Option>
					<Option value={45}>45 Days</Option>
					<Option value={60}>60 Days</Option>
					<Option value={90}>90 Days</Option>
					<Option value={120}>120 Days</Option>
				</Select>

			</div>
		)

	}

	constructor( props ){

		super(props);

		this.state = {
			quotationUrl: `${API_ENDPOINT}/api/orders/quotation/${this.props.quotation.cart._id}/undefined?time=${new Date().getTime()}`,
			manualDeliverySwitchDisable: false,
			manualDeliveryInputDisable:  this.props.quotation.cart.quoteAndForgetFreeDelivery,
			customPlatformFeeActive: false, 
			customPlatformFee: 0
		}
	
		// if enterprise and have not sent invoice, get credit term days and set
		if( props.quotation.cart.punchoutCart && !props.quotation.cart.lastContact.invoiceDate ){
			_getEnterpriseData( props.quotation.cart.user.punchoutId )
				.then( res => {

					this.updatePaymentTermDays( res.data.enterprise.creditTermDays );

				})
		}	

		this._asyncPostChangeQuotationPoRefNumber = debounce( this._asyncPostChangeQuotationPoRefNumber, 400 );
		this._postManualDeliveryCharge = debounce(this._postManualDeliveryCharge, 400);
		this._postCustomDeliveryFee = debounce(this._postCustomDeliveryFee, 400);
		this._postCustomDeliveryNote = debounce(this._postCustomDeliveryNote, 400);
		this._putCustomPlatformFee = debounce(this._putCustomPlatformFee, 400);
	}

	_asyncPostChangeQuotationPoRefNumber = ( poRefNumber ) => {

		_postChangeQuotationPoRefNumber( this.props.quotation.cart._id, poRefNumber )
			.then( res => {

				this.setState({
					quotationUrl: `${API_ENDPOINT}/api/orders/quotation/${this.props.quotation.cart._id}/undefined?time=${new Date().getTime()}`
				});

			});
	}

	updateCurrency = ( currency ) => {
		console.log( currency );

		let msg = message.loading('Updating currency..',0);

		_postSetQuotationCurrency({
			currency,
			quotationId: this.props.quotation.cart._id
		})
			.then( res => {
				
				msg();
				message.success(`Currency updated to ${res.data.currency}`);

				this.setState({
					quotationUrl: `${API_ENDPOINT}/api/orders/quotation/${this.props.quotation.cart._id}/undefined?time=${new Date().getTime()}`
				});

				this.props.setQuotationCurrency( res.data.currency );

			})
	}

	updatePaymentTermDays = ( paymentTermDays ) => {

		message.loading('Updating payment terms..',0);
		
		_postSetQuotationPaymentTermDays({
			paymentTermDays,
			quotationId: this.props.quotation.cart._id
		})
			.then( res => {
				
				message.destroy();
				message.success(`Payment terms updated to ${res.data.paymentTermDays} days`);

				this.setState({
					quotationUrl: `${API_ENDPOINT}/api/orders/quotation/${this.props.quotation.cart._id}/undefined?time=${new Date().getTime()}`
				});

				this.props.setQuotationPaymentTermDays( res.data.paymentTermDays );

			})
	}

	onChangePoRefNumber = ( e ) => {
		
		const { value } = e.target;

		this._asyncPostChangeQuotationPoRefNumber( value );

	}

	onToggleFreeDelivery = ( checked ) => {

		this.setState({
			manualDeliveryInputDisable : !this.state.manualDeliveryInputDisable});	
		_postToggleQuotationFreeDelivery({
			freeDelivery: checked,
			quotationId: this.props.quotation.cart._id,
		})
			.then( res => {
				this.setState({
					quotationUrl: `${API_ENDPOINT}/api/orders/quotation/${this.props.quotation.cart._id}/undefined?time=${new Date().getTime()}`
				});

				this.props.setQuotationFreeDelivery(
					checked
				);
			})
	}

	onToggleGstWaived = ( checked ) => {
		_postToggleQuotationGstWaived({
			gstWaived: checked,
			quotationId: this.props.quotation.cart._id
		})
			.then( res => {
				this.setState({
					quotationUrl: `${API_ENDPOINT}/api/orders/quotation/${this.props.quotation.cart._id}/undefined?time=${new Date().getTime()}`
				});

				this.props.setQuotationGstWaived(
					checked
				);
			})
	}

	/* DELIVERY FEE */
	
	_postCustomDeliveryFee = ( _deliveryCharge ) => {

		if ( !isNaN(_deliveryCharge) ){

			const cartId = this.props.quotation.cart._id
			
			// axios({
			// 	url: `${API_ENDPOINT}/api/admin/quotation/${cartId}/custom-delivery`,
			// 	method: 'post',
			// 	withCredentials: true,
			// 	data: {

			// 		deliveryCharge: _deliveryCharge
					
			// 		}
			// })
			_postCustomDeliveryFee( _deliveryCharge, cartId )
				.then( () => {
						
					this.setState({
						quotationUrl: `${API_ENDPOINT}/api/orders/quotation/${cartId}/undefined?time=${new Date().getTime()}`
					});
	
					message.destroy()
	
					if( _deliveryCharge > 0 ){
						message.success(`Added delivery charge of ${_deliveryCharge}`, 1.5);
					} else {
						message.success(`Set delivery charge back to normal`, 1.5);
					}
	
	
	
				})
		} else {
			message.warning('Please enter a valid delivery charge')
		}

	}

	setCustomDeliveryFee = (deliveryCharge) => {

		let _deliveryCharge;

		if (deliveryCharge.length === 0){

			_deliveryCharge = 0
			this.setState({
				manualDeliverySwitchDisable : false
			});

		} else {

			_deliveryCharge = parseFloat( deliveryCharge );
			this.setState({
				manualDeliverySwitchDisable : true
			})
		}

		
		this._postCustomDeliveryFee( _deliveryCharge )



			// _postManualDeliveryCharge({
			// 	deliveryCharge: e,
			// 	quotationId: this.props.quotation.cart._id
			// })
			// .then( res => {
			// 	this.setState({
			// 		quotationUrl: `${API_ENDPOINT}/api/admin/quotation/delivery/${this.props.quotation.cart._Id}/undefined?time=${new Date().getTime()}`
			// 	});
			// })
				
	}

	/* DELIVERY NOTE */


	_postCustomDeliveryNote = ( _deliveryNote ) => {

		const cartId = this.props.quotation.cart._id
		
		_postCustomDeliveryNote( _deliveryNote, cartId )
			.then( () => {
					
				message.destroy()

				if( _deliveryNote.length > 0 ){
					message.success(`Added delivery note`, 1.5);
				} else {
					message.success(`Removed delivery note`, 1.5);
				}

			})

	}

	setCustomDeliveryNote = (deliveryNote) => {

		let _deliveryNote = deliveryNote.trim()
		this._postCustomDeliveryNote( _deliveryNote )
				
	}

	/* PLATFORM FEE */
	setCustomPlatformFee = (customPlatformFeeActive, customPlatformFee) => {

		this.setState({
			customPlatformFeeActive, 
			customPlatformFee
		})

		this._putCustomPlatformFee(customPlatformFeeActive, customPlatformFee)

	}

	_putCustomPlatformFee = (customPlatformFeeActive, customPlatformFee) => {

		const cartId = this.props.quotation.cart._id

		_putCustomPlatformFee(customPlatformFeeActive, customPlatformFee, cartId)
		.then( () => {
						
			this.setState({
				quotationUrl: `${API_ENDPOINT}/api/orders/quotation/${cartId}/undefined?time=${new Date().getTime()}`
			});

			message.destroy()

			if( customPlatformFeeActive ){
				message.success(`Added custom platform fee of ${customPlatformFee}%`, 1.5);
			} else {
				message.success(`Removed custom platform fee`, 1.5);
			}

		})

	}
}

export default connect(
	state => ({
		quotation: state.quotation
	}),

	dispatchEvent => ({
		setQuotationCurrency: ( currency ) => dispatchEvent( setQuotationCurrency( currency ) ),
		setQuotationGstWaived: ( checked ) => dispatchEvent( setQuotationGstWaived( checked ) ),
		setQuotationFreeDelivery: ( checked ) => dispatchEvent( setQuotationFreeDelivery( checked ) ),
		setQuotationPaymentTermDays: ( paymentTermDays ) => dispatchEvent( setQuotationPaymentTermDays(paymentTermDays) )
	})
)(QuotationPricing);


// WEBPACK FOOTER //
// ./src/components/quotation/add-quotation-modal/pricing.js